import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "../../sass/_document.scss";
import "../../sass/bootstrap.scss";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import ChannelSliders from "../components/ChannelSliders/ChannelSliders";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";
import Search from "../../src_bk/components/search-bar";
import Api from "../utils/api_calls";

// Channel IDs for the gallery
// 1st channel: 82801450 > Latest
// 2nd channel: 239422350 > Steiner Stories Across America
// 3rd channel: 239422355 > Tractor Repair Videos
// 4th channel: 236982741 > Tractor Shows
const CHANNEL_IDS = [82801450, 239422350, 239422355, 236982741];

const Home = () => {
    const [channelsGallery, setChannelsGallery] = useState([]);
    useEffect(() => {
        (async () => {
            try {
                const channels = await Promise.all(
                    CHANNEL_IDS.map(async (id) => {
                        const channelInfoUrl = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${id}`;
                        const videosUrl = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${id}/videos`;
                        const { data: info } = await Api.channelInfo(channelInfoUrl);
                        const { data: vids } = await Api.channelInfo(videosUrl);
                        return { ...info, videos: vids || [] };
                    })
                );
                setChannelsGallery(channels);
            } catch (err) {
                console.error("Failed to load channel gallery:", err);
            }
        })();
    }, []);

    return (
        <div
            data-testid="homepage"
            className={"document-body " + theme.hub_wrapper_css_class}
        >
            <div className="container" style={{ margin: "1em auto 0" }}>
                <div className="row">
                    <div className="col-md-2 home-top-title">
                        <p>Videos</p>
                    </div>
                    <div className="col-md-10">
                        <Search />
                    </div>
                    <div className="filters-divider" />
                </div>
            </div>
            <Breadcrumbs keepOnMobile />
            <ChannelSliders channels={channelsGallery} />
        </div>
    );
};

const targetEl = document.getElementById("tvp-video-gallery");

if (targetEl) {
    createRoot(targetEl).render(<Home />);
}
